import React, { useContext } from 'react';

import { ApiPortfolioState } from './ApiPortfolioState';

interface AnswerParams {
  //* userkey, lessonkey, layer are used to get an answer from LessonComponentViewWithAnswer.
  userkey: number;
  lessonkey: number;
  layer: number;
  position?: number; // position => component key
}

export interface LessonState {
  answerParams: AnswerParams;
  //* The state when the lesson player is launching.
  //* Used to decide showing the 'Withdrow' button next to the 'Submitted' label.
  state: ApiPortfolioState;
}

export interface LessonPlayerContextModel {
  preview: boolean;
  coursekey: number;
  lessonState: LessonState;
}

const LessonPlayerContext = React.createContext<LessonPlayerContextModel>({
  preview: true,
  coursekey: -1,
  lessonState: {} as LessonState
});

export const useLessonPlayerContext = () => useContext(LessonPlayerContext);

export const LessonPlayerContextProvider = LessonPlayerContext.Provider;
export const LessonPlayerContextConsumer = LessonPlayerContext.Consumer;
export default LessonPlayerContext;
